import { Component } from 'react';
import { func, string, array } from 'prop-types';
import zxcvbn from 'zxcvbn';

import { PASSWORD_STRENGTH_MESSAGES } from './common';

/*

  Validation Layer, second level of the input tree.
  This component will be responsible for handling all the needed validation
  and passing the errors down the tree.

  Rules:
    error (true|false) ===> valid or invalid input
    className 'fair|weak|strong ===> Password specific Errors
    description ===> description of the error

*/

export default class WithValidation extends Component {
  static propTypes = {
    value: string.isRequired,
    validations: array,
    render: func.isRequired
  };

  validateRequired = inputValue => {
    if (!inputValue.length) {
      return { error: true, description: '*Required field.' };
    } else {
      return { error: false, description: '' };
    }
  }

  validateCVV = inputValue => {
    if (inputValue.length > 0 && inputValue.length < 3) {
      return { error: true, description: 'That\'s not a valid CVV number.' };
    }
  }

  validateCreditCard = inputValue => {
    if (inputValue.length > 16) {
      return {
        error: true,
        description: 'This does not appear to be a valid credit card.'
      };
    }
  }

  validatePassword = inputValue => {
    if (!inputValue.length) { return { error: false, description: '' }; }

    if (inputValue.length > 0 && inputValue.length < 8) {
      return PASSWORD_STRENGTH_MESSAGES.length;
    }

    else {
      // score is the integer that the library returns after testing the strength
      // of the input string. It's a value between 0 (weak) and 4 (strong)
      const { score } = zxcvbn(inputValue);
      let error = { error: false };

      switch (score) {
        case 0:
        case 1:
          error = PASSWORD_STRENGTH_MESSAGES.weak;
          break;
        case 2:
          error = PASSWORD_STRENGTH_MESSAGES.fair;
          break;
        case 3:
        case 4:
          error = PASSWORD_STRENGTH_MESSAGES.strong;
          break;
      }

      return error;
    }
  }

  validateEmail = inputValue => {
    const regex = /\S+@\S+\.\S+/;
    let error = { error: false };

    if (!regex.test(inputValue)) {
      return error = {
        error: true,
        description: 'This does not appear to be a valid email address.'
      };
    }

    return error;
  }

  validationMap = {
    'required': this.validateRequired,
    'password': this.validatePassword,
    'credit-card': this.validateCreditCard,
    'cvv': this.validateCVV,
    'email': this.validateEmail,
  };

  render() {
    const { value, validations } = this.props;
    let error = { error: false };

    if (validations) {
      let i = 0;

      // If some validation matched (we got some error) we stop iterating
      // through the rest of the errors. This allows for multiple validations
      // on a single input.
      while (i < validations.length && !error.error) {
        error = this.validationMap[validations[i]](value);

        i++;
      }
    }

    return this.props.render(error);
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/WithValidation.js